<form class="xs-search-and-pick" [formGroup]="searchForm">
  <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
    <span
      *ngIf="showSearchAndCancelIcons && isSearchIconDisplay"
      class="hd-icon hd-icon-search search-icon"
      id="searchIcon"
    ></span>
    <input
      #autoCompleteInput
      type="text"
      matInput
      [ngClass]="{ addIndent: showSearchAndCancelIcons, removeIndent: !isSearchIconDisplay }"
      matAutocompleteTrigger
      #trigger="matAutocompleteTrigger"
      class="custom-panel"
      [matAutocomplete]="auto"
      [placeholder]="placeholder"
      matTooltip="{{ !!selectedItem ? displayFn(selectedItem, 'title') : '' }}"
      matTooltipPosition="above"
      matTooltipClass="assist-mat-tooltip"
      formControlName="inputControl"
      (focus)="removeSearchIcon()"
      (focusout)="onFocusOutEvent($event)"
      (keyup.enter)="submitValue()"
    />
    <span
      *ngIf="showSearchAndCancelIcons && searchInputText.value"
      class="hd-icon hd-icon-close close-icon"
      (click)="clearSearch()"
    ></span>
  </mat-form-field>
  <mat-autocomplete
    panelClass="sa-mat-autocomplete-panel"
    disableRipple
    #auto="matAutocomplete"
    [displayWith]="displayWrapped"
    sa-stop-propagation
    class="reporter-panel"
  >
    <div id="autoComplete" tabindex="-1">
      <ng-container>
        <mat-option
          disableRipple
          sa-stop-propagation
          *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper"
          [value]="wrappedItem"
          (onSelectionChange)="optionClicked(wrappedItem.item)"
          class="reporterCardTemplate"
        >
          <div class="searchResult">
            <div class="userBadge">
              <xs-user-badge
                [size]="'sm'"
                [userName]="wrappedItem.item.fullName || wrappedItem.item.displayName"
              ></xs-user-badge>
            </div>
            <div class="userDetail">
              <span
                class="userInfo firstRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.displayName"
                [fullText]="wrappedItem.item.displayName"
              ></span>
              <span
                class="userInfo firstRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.fullName"
                [fullText]="wrappedItem.item.fullName"
              ></span>
              <span
                class="userInfo lastRow"
                *ngIf="wrappedItem.item.email"
                sa-ellipsis
                [fullText]="wrappedItem.item.email"
              ></span>
            </div>
          </div>
        </mat-option>
        <mat-option id="autoComplete" *ngIf="searchEmpty() && !isSearching()">
          <span class="search-and-pick-no-match">{{ 'searchAndPick_NoMatchesFound_Caption' | xsI18n }}</span>
        </mat-option>
      </ng-container>
    </div>
  </mat-autocomplete>
</form>
